var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossButtonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "crossButtonIconPath",
    d: "M11.1965 9.99308L15.8859 5.30375C16.038 5.15158 16.038 4.88876 15.8859 4.7366L15.2634 4.11412C15.1112 3.96196 14.8484 3.96196 14.6963 4.11412L9.99308 8.80346H9.97925L5.30375 4.11412C5.15158 3.96196 4.88876 3.96196 4.7366 4.11412L4.11412 4.7366C3.96196 4.88876 3.96196 5.15158 4.11412 5.30375L8.80346 9.99308V10.0069L4.21095 14.6133C4.05879 14.7654 4.05879 15.0282 4.21095 15.1804L4.83343 15.8029C4.98559 15.955 5.24841 15.955 5.40058 15.8029L10.0069 11.1965H10.0207L14.6271 15.8029C14.7793 15.955 15.0421 15.955 15.1942 15.8029L15.8167 15.1804C15.9689 15.0282 15.9689 14.7654 15.8167 14.6133L11.1965 9.99308C11.1827 10.0069 11.1827 10.0069 11.1965 9.99308Z",
    fill: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossButtonIcon);
export default __webpack_public_path__ + "static/media/cross-button-icon.849f6be0.svg";
export { ForwardRef as ReactComponent };